module.exports = __webpack_public_path__ + "static/media/notdata.6145be45.png";